import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { utils } from 'src/app/modules/libs/utils';
import { PVData } from './cl-image-upload-table-data/cl-image-upload-table-data.component';

@Injectable({
  providedIn: 'root'
})
export class ClImageUploadTableDataService {

  formatValue(numberToFormat?: number | null) {
    if (numberToFormat != undefined && numberToFormat != null) {
      if (numberToFormat == 0) return '0.00';
      if (Math.abs(numberToFormat) < .0001)
        return numberToFormat.toExponential(2).toString().replace('e', ' x 10').replace('-', '<sup>-').replace('+', '<sup>');
      else return numberToFormat.toFixed(2).toString();
    }
    else return null;
  }
}
